import { render, staticRenderFns } from "./shop-info.vue?vue&type=template&id=5aa7b288&scoped=true&"
import script from "./shop-info.vue?vue&type=script&lang=js&"
export * from "./shop-info.vue?vue&type=script&lang=js&"
import style0 from "./shop-info.vue?vue&type=style&index=0&id=5aa7b288&scoped=true&lang=css&"
import style1 from "./shop-info.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa7b288",
  null
  
)

export default component.exports